export default "__VITE_ASSET__Ktc9BAtU__"